import React, { useState } from "react";
import { Checkbox } from "@vds/checkboxes";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";

function CustomRouterModal({
  onClick = () => { },
  onClose = () => { },
  opened = false
}) {
  const [isChecked, setChecked] = useState(false);
  const WIFI7 = window.sessionStorage.getItem('isWIFI7');

  function handlePrimary() {
    try {
      if (isChecked) {
        setChecked(false);
        onClick();
      }
    } catch (e) {
      console.error(e);
    }
  }
  function handleClose() {
    try {
      setChecked(false);
      onClose();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <>
    {WIFI7 ?
    <Modal
      opened={opened}
      surface="light"
      disableOutsideClick={true}
      ariaLabel="CustomRouterModal"
    >
      <ModalTitle>
        Will you use your own router?
      </ModalTitle>
      <ModalBody>
      <br /> <br />
        <b>Use your own router</b>
        <p>If you supply your own access point or router you may not receive the full benefits of your services. Verizon only installs and supports Verizon-branded access points and routers.</p>
        <b>Whole-Home Wi-Fi Customers</b>
        <p>Certain features of Whole-Home Wi-Fi can be supported only by the Wi-Fi Access Point (CHR30A/CHR30B), Verizon Router (CR1000/A/CR1000B), or Fios Router (G3100). The Home Wi-Fi Health Check is not possible with older Verizon routers or with any non-Verizon routers. Home Awareness can be supported only by the Fios Router (G3100). The feature will not work with a legacy or prior router model or with any router not provided by Verizon.</p>
        <b>Will you use your own Wi-Fi Access Point or Router?</b>
        <p>Note we only install and support Verizon-branded access points and routers. If you use your own access point or router, non-Verizon branded, you many not receive the full benefits of your services.</p>
        <p>Please review and acknowledge the following information.</p>
        <b>Internet Customers&#x3A;</b>
        <p>We only recommend the following access points or routers for Fios Internet speeds:</p>
        <ul>
          <li>Wi-Fi Access Point (CHR30A/CHR30B) or Verizon Router (CR1000A/CR1000B) for all internet plans.</li>
          <li>Fios Router (G3100) for all internet plans up to 1 Gig.</li>
          <li>BHR1 or BHR2 routers, which are Retired Devices, cannot support speeds above 25Mbps (Wi-Fi) or 95Mbps (wired), and are subject to a monthly router maintenance charge.</li>
          <li>•Fios Advanced Wi-Fi Router (BHR3), which is a Retired Device, only supports speed up to 130Mbps (Wi-Fi) or up to 948Mbps (wired).</li>
          <li>Fios Quantum Gateway Router (G1100), which is a Retired Device, supports all internet plans up to 1 Gig.</li>
          <li>Non-Verizon access point or router: We do not advise on how a non-Verizon access point or router will impact Fios Home Internet service.</li>
        </ul>
        <b>Fios TV One Customers:</b>
        <p>We do not recommend access points or routers other than the Wi-Fi Access Point (CHR30A/CHR30B), Verizon Router (CR1000A/CR1000B), or Fios Router (G3100). For customers who choose to use a different access point or router, please note:</p>
        <ul>
          <li>You must supply a MoCA capable access point or router or MoCA adapter in order for your Fios TV service to function.</li>
          <li>The Wi-Fi connectivity feature will not work. Fios TV One and Fios TV One Minis will require a coax cable outlet connection.</li>
          <li>Fios TV service may not have full functionality.</li>
          <li>Verizon will not provide technical support for TV issues caused by non-Verizon access points or routers.</li>
        </ul>
        <b>All Fios TV Customers:</b>
        <p>We do not recommend access points or routers other than the Wi-Fi Access Point (CHR30A/CHR30B), Verizon Router (CR1000A/CR1000B), or Fios Router (G3100). Failure to have a Verizon branded access point or router can impact access to features like:</p>
        <ul>
          <li>Guide</li>
          <li>Video-on-Demand</li>
          <li>Pay-per-View</li>
        </ul>
        <b>Streaming Device Connection Customers:</b>
        <p>We do not recommend access points or routers other than the Wi-Fi Access Point (CHR30A/CHR30B), Verizon Router (CR1000A/CR1000B), or Fios Router (G3100). If you choose to use a different access point or router, you may not be able to access all channels or manage and stream DVR recordings through the Verizon Home app.</p>
        <b>Fios TV+ Customers:</b>
        <p>We do not recommend access points or routers other than the Wi-Fi Access Point (CHR30A/CHR30B), Verizon Router (CR1000A/CR1000B), or Fios Router (G3100).</p>
        <p>For customers who choose to use a different access point or router, advise:</p>
        <ul>
          <li>You must supply a MoCA capable access point or router or MoCA adapter in order for your Fios TV service to function.</li>
          <li>The Wi-Fi connectivity feature will not automatically connect.</li>
          <li>Fios TV service may not have full functionality.</li>
          <li>Verizon will not provide technical support for TV issues caused by non-Verizon access points or routers.</li>
        </ul>
        <Checkbox
          onChange={() => setChecked(!isChecked)}
          label="I understand that if I use an access point or router other than the Verizon models mentioned above, I many not receive the full benefits of my service."
        >
        </Checkbox>
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            disabled: !isChecked,
            children: 'Continue',
            onClick: (e) => handlePrimary(e),
          },
          close: {
            children: 'Cancel',
            onClick: (e) => handleClose(e),
          },
        }}
      />
      {/* <br /><br /><br /><br /> */}
    </Modal>
    : <Modal
    opened={opened}
    surface="light"
    disableOutsideClick={true}
    ariaLabel="CustomRouterModal"
    onOpenedChange={(open)=>{
      if(!open){
        handleClose()
      }
    }}
  >
    <ModalTitle>
      Will you use your own router?
    </ModalTitle>
    <ModalBody>
      <p>Note we only install and support Verizon-branded routers. If you use own router, you may not receive the full benefits of your Verizon services.</p>
      <p>Please review and acknowledge the following information.</p>
      <b>Internet Customers&#x3A;</b>
      <p>We only recommend the Verizon Router (CR1000A/CR1000B) for any Fios speed up to 2 Gigabit; Fios Router (G3100) & Fios Quantum Gateway Router (G1100) for any Fios speed up to 1 Gigabit.</p>
      <p>Verizon&#x27;s older router model, the Fios Advanced Wi-Fi Router (Actiontec MI424WR) which is a Retired Device, only supports speed up to 130Mbps (Wi-Fi) or up to 948Mbps (wired).</p>
      <p>We do not advise on how any non-Verizon router will impact Fios Internet service.</p>
      <b>Fios TV One Customers&#x3A;</b>
      <p>We do not recommend routers other that the Verizon Router (CR1000A/CR1000B), Fios Router (G3100) or Fios Quantum Gateway Router (G1100). For customers who choose to use a different router, please note&#x3A;</p>
      <ul>
        <li>You must supply a MoCA capable router or MoCA adapter in order for your TV service to function.</li>
        <li>The Wi-Fi connectivity feature will not work. Fios TV One & Fios TV One Minis will require a coax cable outlet connection.</li>
        <li>Your TV serivce may not have full functionality</li>
        <li>Verizon will not provide technical support for TV issues caused by use of non-Verizon routers.</li>
      </ul>
      <b>All Fios TV Customers&#x3A;</b>
      <p>We do not recommend routers other than the Verizon Router (CR1000A/CR1000B), Fios Router (G3100) or Fios Quantum Gateway Router (G1100). Failure to have a Verizon branded router can impact access to features like</p>
      <ul>
        <li>Guide</li>
        <li>Video-on-Demand</li>
        <li>Pay-per-View</li>
      </ul>
      <b>Streaming Device Connection Customers&#x3A;</b>
      <p>We do not recommend routers other than the Verizon Router (CR1000A/CR1000B), Fios Router (G3100) and Fios Quantum Gateway Router (G1100). If your choose to use a different router, you may not be able to access all channels or manage and stream DVR recordings through the Fios TV Home app.</p>
      <Checkbox
        onChange={() => setChecked(!isChecked)}
        label="I understand that if I use a router other than the Verizon models meantioned above, I may not receive the full benefits of my service."
      >
      </Checkbox>
    </ModalBody>
    <ModalFooter
      buttonData={{
        primary: {
          disabled: !isChecked,
          children: 'Continue',
          onClick: (e) => handlePrimary(e),
        },
        close: {
          children: 'Cancel',
          onClick: (e) => handleClose(e),
        },
      }}
    />
    {/* <br /><br /><br /><br /><br /><br /> */}
  </Modal>
    }
    </>
  );
}

export default CustomRouterModal;